import { searchCharactor } from 'src/util/entryHelper'

type ObjectUrl = {
  title: string
  url: string
}

export class Charactor {
  private _id: string
  private _name: string
  private _objectUrls: ObjectUrl[]
  private _imageIcon: string

  constructor(name: string, objectUrls: ObjectUrl[]) {
    const chara = searchCharactor(name)
    this._id = chara?.id || name
    this._name = name
    this._objectUrls = objectUrls
    this._imageIcon = chara?.image || ''
  }

  public get id(): string {
    return this._id
  }
  public set id(value: string) {
    this._id = value
  }
  public get name(): string {
    return this._name
  }
  public set name(value: string) {
    this._name = value
  }
  public get objectUrls(): ObjectUrl[] {
    return this._objectUrls
  }
  public set objectUrls(value: ObjectUrl[]) {
    this._objectUrls = value
  }
  public get imageIcon(): string {
    return this._imageIcon
  }
  public set imageIcon(value: string) {
    this._imageIcon = value
  }
}
